// @ts-nocheck

import React, { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

import useMergeProps from '../../../hooks/useMergeProps';
import GRBanner from '../components/GRBanner';
import useOpenGRView from '../hooks/useOpenGRView';
import { selectGRGlobalStartDate, selectGRGlobalStatus } from '../selectors/global';
import { selectIsGREnabledAndNotForbidden } from '../selectors/specifics/selectGRRuntime';
import { GRGlobalStatuses } from '../types/global';

type GRBannerContainerProps = {
  className?: string;
};

const GRBannerContainer = (ownProps: GRBannerContainerProps) => {
  const isGREnabled = useSelector(selectIsGREnabledAndNotForbidden);
  const GROpeStatus = useSelector(selectGRGlobalStatus);
  const operationStartDate = useSelector(selectGRGlobalStartDate);
  const openGRView = useOpenGRView();

  const selectedProps = useMemo(() => ({ showCountdown: Date.now() >= operationStartDate }), [operationStartDate]);

  const onClick = useCallback(() => {
    openGRView();
  }, [openGRView]);

  const otherProps = useMemo(() => ({ onClick }), [onClick]);

  const enhancedProps = useMergeProps({ ownProps, selectedProps, otherProps });

  const shouldDisplay = GROpeStatus === GRGlobalStatuses.RUNNING && isGREnabled;

  return shouldDisplay ? <GRBanner {...enhancedProps} /> : null;
};

export default GRBannerContainer;
